export default "__VITE_ASSET__DhrfIk2q__"